var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.75L29.795 5.5625L25 7.75L29.795 9.955L32 14.75L34.1875 9.955L39 7.75L34.1875 5.5625M14.5 6L10.125 15.625L0.5 20L10.125 24.375L14.5 34L18.875 24.375L28.5 20L18.875 15.625M32 25.25L29.795 30.045L25 32.25L29.795 34.4375L32 39.25L34.1875 34.4375L39 32.25L34.1875 30.045",
    fill: "#ECD410"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedGold);
export default __webpack_public_path__ + "static/media/featured-gold.b3664b5bb54e343b725f915494f105e6.svg";
export { ForwardRef as ReactComponent };